import { render, staticRenderFns } from "./SwappingSquaresSpinner.vue?vue&type=template&id=8265a670&scoped=true&"
import script from "./SwappingSquaresSpinner.vue?vue&type=script&lang=js&"
export * from "./SwappingSquaresSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SwappingSquaresSpinner.vue?vue&type=style&index=0&id=8265a670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8265a670",
  null
  
)

export default component.exports